import script from "./AddSubscriptionUserField.vue?vue&type=script&setup=true&lang=js"
export * from "./AddSubscriptionUserField.vue?vue&type=script&setup=true&lang=js"

import "./AddSubscriptionUserField.vue?vue&type=style&index=0&id=4cc20afe&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4cc20afe"]])

export default __exports__